import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "contents" }
const _hoisted_2 = {
  key: 0,
  class: "contents-title"
}

import { provide, ref, watch } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentsArea',
  setup(__props) {

const contentsTitle = ref('Contents Area');
const contentsDescription = ref('Contents Description');
const showContentsTitle = ref(true);

provide('contentsTitle', contentsTitle);
provide('contentsDescription', contentsDescription);

const route = useRoute();

watch(
  () => route.path,
  (newPath) => {
    showContentsTitle.value = !newPath.includes('/chat');
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showContentsTitle.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", null, _toDisplayString(contentsTitle.value), 1),
          _createElementVNode("p", null, _toDisplayString(contentsDescription.value), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}
}

})